/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Demo_Skip_GeneralInputs */

const en_funnel_demo_skip_general = /** @type {(inputs: Funnel_Demo_Skip_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A natural, human voice, not a robot`)
};

const es_funnel_demo_skip_general = /** @type {(inputs: Funnel_Demo_Skip_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una voz natural y humana, no un robot`)
};

/**
* | output |
* | --- |
* | "A natural, human voice, not a robot" |
*
* @param {Funnel_Demo_Skip_GeneralInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_demo_skip_general = /** @type {((inputs?: Funnel_Demo_Skip_GeneralInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Demo_Skip_GeneralInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_demo_skip_general(inputs)
	return en_funnel_demo_skip_general(inputs)
});